module.exports = __webpack_public_path__ + "media/warranty-claim/proof-of-roof-57958385.svg";